module.exports = __webpack_public_path__ + "img/城市相框-2.204bd882.jpg";